import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';

import { AvailabiityRequestDTO, AvailabilityRes, BookedDatesRequestDTO, UseAvailabilityOptions } from '../types';
import Utils from '@/utils/util';

export const getAvailabilities = ({ data, headers }: AvailabiityRequestDTO): Promise<AvailabilityRes[]> => {
  const {businessId, duration, date, userId, serviceId, tz, serviceType} = data;
  const reqParam: UseAvailabilityOptions = { duration, date };
  if (userId) {
    reqParam.userId = userId;
  }
  if (serviceId) {
    reqParam.serviceId = serviceId;
  }
  if (tz) {
    reqParam.tz = tz;
  }

  if (serviceType === Utils.SERVICE_TYPES.GROOMING) {
    return axios.get(`/business/${businessId}/calendar/availability`, {
      params: reqParam,
      headers: {
        'loc-id': headers?.['loc-id'],
      },
    });
  }

  return axios.post(`parent/daycare/availability`, reqParam, {
    headers: {
      'loc-id': headers?.['loc-id'],
    },
  });
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof getAvailabilities>;
};

export const useGetAvailabilities = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getAvailabilities,
  });
};



export const getBookedDates = ({ data, headers }: BookedDatesRequestDTO): Promise<any> => {
  const {startDate, endDate} = data;
    return axios.get(`/parent/boarding/availability?startDate=${startDate}&endDate=${endDate}`, {
      headers: {
        'loc-id': headers?.['loc-id'],
      },
    });
  }


type UseGetBookedDatesOption = {
  config?: MutationConfig<typeof getBookedDates>;
};

export const useGetBookedDates = ({ config }: UseGetBookedDatesOption = {}) => {
  return useMutation({
    ...config,
    mutationFn: getBookedDates,
  });
};

